import { z } from 'zod';

export const COMMUNICATION_TYPES = [
  'email',
  'call',
  'meeting',
  'note',
  'whatsapp',
  'demo',
  'video_call',
  'sms',
] as const;
export const communicationTypeEnum = z.enum(COMMUNICATION_TYPES);
export type CommunicationType = z.infer<typeof communicationTypeEnum>;

export const COMMUNICATION_DIRECTIONS = ['inbound', 'outbound'] as const;
export const communicationDirectionEnum = z.enum(COMMUNICATION_DIRECTIONS);
export type CommunicationDirection = z.infer<typeof communicationDirectionEnum>;

/** Logged against either a `SalesLead` or a `CrmCustomer` — the parent is determined by which route it's posted to, not a field in this schema. */
export const createCommunicationSchema = z.object({
  type: communicationTypeEnum,
  direction: communicationDirectionEnum.default('outbound'),
  subject: z.string().trim().max(200).optional().or(z.literal('')),
  content: z.string().trim().max(5000).optional().or(z.literal('')),
  duration: z.coerce.number().min(0).default(0),
  outcome: z.string().trim().max(500).optional().or(z.literal('')),
  nextAction: z.string().trim().max(500).optional().or(z.literal('')),
  scheduledAt: z.coerce.date().optional(),
});

export type CreateCommunicationInput = z.infer<typeof createCommunicationSchema>;
